import { useState } from 'react';

import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import Content from './content';

const DiscretionaryHoursAllocation = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<CustomButton
				title="Allocate Admin Hours"
				onClick={() => setOpen(true)}
				buttonType="outlined"
				className="marginBottom16"
			/>
			<CustomAlert
				open={open}
				onClose={() => setOpen(false)}
				title="Allocate Admin Hours"
				Content={Content}
				maxWidth="sm"
			/>
		</>
	);
};

export default DiscretionaryHoursAllocation;
